// "Publicar ou agendar" dentro do editor edvid — o MESMO PublishModal do JobCard,
// com a legenda (captionSeo) e a trilha do Instagram (musicSelection) do job. O
// backend mantém output.finalVideoUrl apontando para o entregável mais recente
// (o corte depois da Fase 1, o final depois da Fase 2), então a URL de publicação
// vem sempre de getVideoEditorAssetUrl(jobId, 'final', 'publish').
import { useState } from 'react';
import { createPortal } from 'react-dom';
import toast from 'react-hot-toast';
import { PublishModal } from '../AssetGallery';
import { composeCaption } from '../../../utils/captionHashtags';
import type { EdvidJobRecord } from '../../../services/api';
import type { EdvidClient } from './useEdvidJob';

export function PublishButton({ job, client, disabled, variant = 'primary', onPublished }: {
  job: EdvidJobRecord;
  client: EdvidClient;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  onPublished: () => void;
}) {
  const [url, setUrl] = useState('');
  const [opening, setOpening] = useState(false);
  const out = (job.output || {}) as Record<string, any>;
  const captionSeo = out.captionSeo || null;
  const music = out.musicSelection || null;
  const filenames = job.input?.originalFilenames || [];

  const open = async () => {
    setOpening(true);
    try {
      setUrl(await client.getPublishUrl(job.id));
    } catch (e: any) {
      toast.error(e?.message || 'Erro ao preparar o vídeo para publicação.');
    } finally { setOpening(false); }
  };

  const asset = url ? {
    id: job.id,
    type: 'video_editor',
    url,
    previewUrl: url,
    caption: composeCaption(captionSeo?.caption || '', captionSeo?.hashtagsFlat || '').body,
    status: 'draft',
    title: filenames.length === 1 ? filenames[0] : `${filenames.length || 1} vídeo(s) editado(s)`,
  } : null;

  return (
    <>
      <button
        type="button"
        onClick={() => void open()}
        disabled={disabled || opening}
        title={disabled ? 'Aguarde o render terminar' : 'Publicar agora ou agendar nas redes conectadas'}
        className={variant === 'primary'
          ? 'rounded-xl bg-emerald-500 px-4 py-2 text-xs font-black text-slate-950 transition-colors hover:bg-emerald-400 disabled:opacity-40'
          : 'rounded-xl border border-emerald-400/40 px-3 py-2 text-xs font-black text-emerald-200 transition-colors hover:bg-emerald-500/10 disabled:opacity-40'}
      >
        {opening ? 'Preparando…' : 'Publicar ou agendar'}
      </button>
      {asset && createPortal(
        // portal próprio acima do editor (z 2147482000): o modal é fixed z-50
        <div className="relative z-[2147483400]">
          <PublishModal
            asset={asset as any}
            allAssets={[asset as any]}
            captionSeo={captionSeo}
            music={music?.enabled === false ? null : music}
            aiGeneratedDefault={false}
            onClose={() => setUrl('')}
            onPublished={() => { setUrl(''); toast.success('Publicado com sucesso!'); onPublished(); }}
          />
        </div>,
        document.body,
      )}
    </>
  );
}
